import React, { useState, useEffect } from "react";



import { addDoc, collection, getDocs, query, orderBy } from "firebase/firestore";
import db from "./Firebase";
import Moment from "moment";
import { extendMoment } from "moment-range";

const AddDoubtSession = () => {
    const [doubtClearingSession, setDoubtClearingSession] = useState([]);
    const [sessionData, setSessionData] = useState({
        name: "",
        created_date: "",
        date: "",
        end_date_time: "",
        link: "",
    });

    const [loading, setLoading] = useState(false);
    const moment = extendMoment(Moment);

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const q = query(collection(db, "nv_doubt_clearing_session"), orderBy("created_date", "desc"));
                const querySnapshot = await getDocs(q);
                const courseData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setDoubtClearingSession(courseData);
            } catch (error) {
                console.error("Error fetching courses:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCourses();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSessionData({ ...sessionData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            // Validate fields
            if (
                !sessionData.name ||
                !sessionData.date ||
                !sessionData.end_date_time ||
                !sessionData.link
            ) {
                alert("Please fill in all required fields.");
                setLoading(false);
                return;
            }

            // Add session data to Firestore
            await addDoc(collection(db, "nv_doubt_clearing_session"), {
                ...sessionData,
                created_date: new Date(),
                date: new Date(sessionData.date),
                end_date_time: new Date(sessionData.end_date_time),
            });

            alert("Session data uploaded successfully!");
            setSessionData({
                name: "",
                created_date: "",
                date: "",
                end_date_time: "",
                link: "",
            });
        } catch (error) {
            console.error("Error uploading session data:", error);
            alert("Error uploading data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div class="p-2">
                <table className="table table-bordered table-hover p-2">
                    <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                        <tr>
                            <th>Course Category</th>
                            <th>Session Date</th>
                            <th>Session End Date Time</th>

                        </tr>
                    </thead>
                    <tbody>
                        {doubtClearingSession.map(course => (
                            <tr key={course.id}>
                                <td>{course.name}</td>
                                <td>{moment(course.date.toDate()).format("DD/MM/YY, h:mm a")}</td>
                                <td>{moment(course.end_date_time.toDate()).format("DD/MM/YY, h:mm a")}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div style={{ maxWidth: "600px", margin: "0 auto", padding: "20px" }}>
                <h2>Add Doubt Session</h2>
                <form onSubmit={handleSubmit}>
                    <div>
                        <label>Course Tag Name:</label>
                        <input
                            type="text"
                            name="name"
                            value={sessionData.name}
                            onChange={handleInputChange}
                            required
                            style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
                        />
                    </div>

                    <div>
                        <label>Session Date:</label>
                        <input
                            type="datetime-local"
                            name="date"
                            value={sessionData.date}
                            onChange={handleInputChange}
                            required
                            style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
                        />
                    </div>

                    <div>
                        <label>End Date & Time:</label>
                        <input
                            type="datetime-local"
                            name="end_date_time"
                            value={sessionData.end_date_time}
                            onChange={handleInputChange}
                            required
                            style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
                        />
                    </div>

                    <div>
                        <label>Session Link:</label>
                        <input
                            type="text"
                            name="link"
                            value={sessionData.link}
                            onChange={handleInputChange}
                            required
                            style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            backgroundColor: loading ? "#ccc" : "#007bff",
                            color: "white",
                            padding: "10px 20px",
                            border: "none",
                            borderRadius: "4px",
                            cursor: loading ? "not-allowed" : "pointer",
                        }}
                    >
                        {loading ? "Uploading..." : "Upload Session"}
                    </button>
                </form>
            </div>
        </>
    );
};

export default AddDoubtSession;
